import { ApiError } from 'models/api/http';
import { LocationPathname } from 'models/app/navigation';
import { Action } from 'models/meta/action';
import { newConsentNotFound } from 'store/new-consent/actions';

import { fetchConsentDetailsFailure } from './actions';

export const handleGetConsentErrors = ({
    error,
    newConsentMode,
    locationPathname,
}: { error: ApiError, newConsentMode?: boolean, locationPathname: LocationPathname }): Action[] => {
    const handlers = [
        {
            predicate: () => newConsentMode && error.message === 'consent not found!',
            handler: () => [
                fetchConsentDetailsFailure({ locationPathname }),
                newConsentNotFound(),
            ],
        },
        {
            predicate: () => true,
            handler: () => [
                fetchConsentDetailsFailure({ locationPathname }),
            ],
        },
    ];

    return handlers.filter(({ predicate }) => predicate())[0].handler();
};
